<template>
  <div class="scheme-section">
    <OverlayProgress :active="loading" />

    <p class="scheme-section__title">Upload a new Scheme</p>
    <form action class="scheme-form">
      <div class="scheme-form__row">
        <p class="scheme-form__label">Type of task:</p>
        <select
          class="scheme-form__select"
          :value="schemeType"
          @change="changeSchemeType"
        >
          <option value="form">Classification</option>
          <option value="segmentation">Segmentation</option>
          <option value="box">Bounding box</option>
        </select>
      </div>
      <div class="scheme-form__row">
        <p class="scheme-form__label">Name of the variable:</p>
        <fg-input
          :value="schemeName"
          @change.native="changeSchemeName"
        ></fg-input>
      </div>
      <div class="scheme-form__row-textarea">
        <p class="scheme-form__label">Values (one per line):</p>
        <textarea
          v-if="this.schemeType === 'form'"
          class="scheme-form__text-area"
          :value="reformTextarea(schemeDescription)"
          @change="changeSchemeDescription"
        ></textarea>
        <div v-else class="scheme-form__colorful-values">
          <scheme-labels></scheme-labels>
        </div>
      </div>
      <div v-if="schemeId !== ''">
        <p-button
          size="sm"
          type="submit"
          style="line-height: 2.4; margin: 0 10px;"
          @click.native="modalToggle"
          >Update</p-button
        >
        <p-button
          size="sm"
          type="submit"
          style="line-height: 2.4; margin: 0 10px;"
          @click.native="clearForm"
          >Cancel</p-button
        >
      </div>
      <p-button
        v-else
        size="sm"
        type="submit"
        style="line-height: 2.4;"
        @click.native="submitSchemesForm"
        >Upload</p-button
      >
    </form>
  </div>
</template>

<script>
import SchemeLabels from "../../../customReusableComponents/SchemeLabels";
import EmptyFieldsError from "../../Notifications/EmptyFieldsError";
import CreateScheme from "../../Notifications/CreateScheme";
import OverlayProgress from "../../../customReusableComponents/OverlayProgress";

export default {
  components: {
    SchemeLabels,
    OverlayProgress
  },
  data() {
    return {
      valueInput: "",
      colorCache: {}
    };
  },
  props: {
    loading: false
  },
  computed: {
    schemeName() {
      return this.$store.getters.getSchemeName;
    },
    schemeType() {
      return this.$store.getters.getSchemeType;
    },
    schemeDescription() {
      return this.$store.getters.getSchemeDescription;
    },
    schemeId() {
      return this.$store.getters.getSchemeId;
    },
    schemeLabels() {
      return this.$store.getters.getSchemeLabels;
    }
  },
  methods: {
    reformTextarea(description) {
      let values = "";
      if (typeof description === "string") {
        values = description;
      } else if (Array.isArray(description)) {
        values = description.join("\n");
      } else {
        values = description.choises.join("\n");
      }

      return values;
    },
    changeSchemeType(e) {
      this.$store.dispatch("onTypeChange", e.target.value);
    },
    changeSchemeName(e) {
      this.$store.dispatch("onNameChange", e.target.value);
    },
    changeSchemeDescription(e) {
      this.$store.dispatch("onDescriptionChange", e.target.value);
    },
    submitSchemesForm() {
      if (this.schemeName === "" || this.schemeType === "") {
        this.$notify({
          component: EmptyFieldsError,
          icon: "ti-alert",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger"
        });
        return;
      }
      let labels = {};

      for (let i = 0; i < this.schemeLabels.length; i++) {
        labels[this.schemeLabels[i].key] = this.schemeLabels[i].value;
      }

      let schemeDescription = labels;

      if (this.schemeType === "form") {
        schemeDescription = {
          name: this.schemeName,
          type: "select",
          choises: this.schemeDescription.split("\n"),
          required: true
        };
      }

      this.$store
        .dispatch("postScheme", {
          name: this.schemeName,
          description: JSON.stringify(schemeDescription),
          type: this.schemeType
        })
        .then(() => {
          this.$notify({
            component: CreateScheme,
            icon: "ti-gift",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success"
          });
        });
    },
    modalToggle() {
      this.$store.dispatch("toggleModal");
    },
    clearForm() {
      this.$store.dispatch("clearScheme");
    }
  }
};
</script>

<style lang="scss" scoped>
.scheme-section {
  position: relative;

  &__title {
    border-bottom: 1px solid #dddddd;
    font-size: 20px;
    padding: 5px 0px;
  }
}

.scheme-form {
  text-align: center;

  &__select {
    width: 211px;
    padding: 10px;
    border: none;
    border-radius: 4px;
    margin-bottom: 1rem;

    &:focus {
      outline: none;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-textarea {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }
  }

  &__label {
    font-size: 16px;
    font-weight: bold;
    text-align: left;
  }

  &__text-area {
    width: 211px;
    height: 100px;
    margin-bottom: 1rem;
    padding: 7px 14px;
  }

  &__colorLabels {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-weight: bold;
  }

  &__color {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>
